import "./style.scss";

export function book_appointment_details_block() {
  const block = document.querySelector(".book_appointment_details_block");
  if (!block) return;
}
